/// <amd-module name="Search/LegacyWebApi/RestClient/Search" />
/**
 * ---------------------------------------------------------
 * Generated file, DO NOT EDIT
 * ---------------------------------------------------------
 *
 * See following wiki page for instructions on how to regenerate:
 *   https://aka.ms/azure-devops-client-generation
 *
 * Configuration file:
 *   search\client\webapilegacy\clientgeneratorconfigs\genclient.json
 */

import { IVssRestClient, IVssRestClientOptions, RestClients } from "VSS/Platform/Context";
import { RestClientBase } from "VSS/Platform/RestClientBase";
import { deserializeVssJsonObject } from "VSS/Platform/Util/Serialization";

import Code = require("Search/LegacyWebApi/Contracts/Code");
import WorkItem = require("Search/LegacyWebApi/Contracts/WorkItem");
import Search_Shared_Contracts = require("Search/LegacyWebApi/Contracts/Search.SharedLegacy");

export interface ISearchRestClient extends IVssRestClient {
    /**
     * Provides a set of results which match the posted advanced query. Returning HttpResponseMessage object so as to obtain the response headers in the auto generated rest client.
     * 
     * @param query - The advanced search query.
     * @param project - Project ID or project name
     */
    postAdvancedCodeQuery(query: Code.SearchQuery, project?: string): Promise<Search_Shared_Contracts.EntitySearchResponseWithActivityId>;
    /**
     * Provides a set of results which match the posted query. Returning HttpResponseMessage object so as to obtain the response headers in the auto generated rest client.
     * 
     * @param query - The search query.
     * @param project - Project ID or project name
     */
    postCodeQuery(query: Code.SearchQuery, project?: string): Promise<Search_Shared_Contracts.EntitySearchResponseWithActivityId>;
    /**
     * Provides a set of results which match the posted query. Returning HttpResponseMessage object so as to obtain the response headers in the auto generated rest client.
     * 
     * @param query - The search query.
     * @param project - Project ID or project name
     */
    postWorkItemQuery(query: WorkItem.WorkItemSearchRequest, project?: string): Promise<Search_Shared_Contracts.EntitySearchResponseWithActivityId>;

	/**
     * Provides a set of results which match the posted query. Returning HttpResponseMessage object so as to obtain the response headers in the auto generated rest client.
     * 
     * @param query - The search query.
	 * @param entityType - the entity type
     * @param project - Project ID or project name
     */
    resultsCount(query: Search_Shared_Contracts.CountRequest, entityType: string, project?: string): Promise<Search_Shared_Contracts.CountResponse>;

    /**
     * Provides an approximate count of results for posted query.
     * 
     * @param query - The search query.
     * @param entityType - The entity for which count query is done.
     */
    fetchPackageResultsCount(query: Search_Shared_Contracts.CountRequest, entityType?: string): Promise<Search_Shared_Contracts.CountResponse>;

    /**
     * Provides a set of results which match the posted query.
     * 
     * @param query - The search query.
     */
    postTenantCodeQuery(query: Code.SearchQuery): Promise<Code.CodeQueryResponse>;

    /**
     * Provides a set of results which match the posted query.
     * 
     * @param query - The search query.
     */
    postTenantWikiQuery(query: Search_Shared_Contracts.WikiSearchQuery): Promise<Search_Shared_Contracts.WikiQueryResponse>;
}

class SearchRestClient extends RestClientBase implements ISearchRestClient {
    constructor(options: IVssRestClientOptions) {
        super(options);
    }

    /**
     * Provides a set of results which match the posted advanced query. Returning HttpResponseMessage object so as to obtain the response headers in the auto generated rest client.
     * 
     * @param query - The advanced search query.
     * @param project - Project ID or project name
     */
    public async postAdvancedCodeQuery(
        query: Code.SearchQuery,
        project?: string
    ): Promise<Search_Shared_Contracts.EntitySearchResponseWithActivityId> {

        return this.beginRequest<Response>({
            apiVersion: "5.0-preview.1",
            method: "POST",
            routeTemplate: "{project}/_apis/search/codeAdvancedQueryResults",
            routeValues: {
                project: project
            },
            body: query,
            returnRawResponse: true
        }).then(async response => {
            const body = await response.text().then(deserializeVssJsonObject);
            const activityIdHeader = response.headers.get("activityid");
            const result: Search_Shared_Contracts.EntitySearchResponseWithActivityId = {
                response: <Search_Shared_Contracts.EntitySearchResponse>body,
                activityId: activityIdHeader ? activityIdHeader.split(',') : []
            };
            return result;
        });
    }

    /**
     * Provides a set of results which match the posted query. Returning HttpResponseMessage object so as to obtain the response headers in the auto generated rest client.
     * 
     * @param query - The search query.
     * @param project - Project ID or project name
     */
    public async postCodeQuery(
        query: Code.SearchQuery,
        project?: string
    ): Promise<Search_Shared_Contracts.EntitySearchResponseWithActivityId> {

        return this.beginRequest<Response>({
            apiVersion: "5.0-preview.1",
            method: "POST",
            routeTemplate: "{project}/_apis/search/codeQueryResults",
            routeValues: {
                project: project
            },
            body: query,
            returnRawResponse: true
        }).then(async response => {
            const body = await response.text().then(deserializeVssJsonObject);
            const activityIdHeader = response.headers.get("activityid");
            const result: Search_Shared_Contracts.EntitySearchResponseWithActivityId = {
                response: <Search_Shared_Contracts.EntitySearchResponse>body,
                activityId: activityIdHeader ? activityIdHeader.split(',') : []
            };
            return result;
        });
    }

    /**
     * Provides a set of results which match the posted query. Returning HttpResponseMessage object so as to obtain the response headers in the auto generated rest client.
     * 
     * @param query - The search query.
     * @param project - Project ID or project name
     */
    public async postWorkItemQuery(
        query: WorkItem.WorkItemSearchRequest,
        project?: string
    ): Promise<Search_Shared_Contracts.EntitySearchResponseWithActivityId> {

        return this.beginRequest<Response>({
            apiVersion: "5.0-preview.1",
            method: "POST",
            routeTemplate: "{project}/_apis/search/workItemQueryResults",
            routeValues: {
                project: project
            },
            body: query,
            returnRawResponse: true
        }).then(async response => {
            const body = await response.text().then(deserializeVssJsonObject);
            const activityIdHeader = response.headers.get("activityid");
            const result: Search_Shared_Contracts.EntitySearchResponseWithActivityId = {
                response: <Search_Shared_Contracts.EntitySearchResponse>body,
                activityId: activityIdHeader ? activityIdHeader.split(',') : []
            };
            return result;
        });
    }

	/**
     * Provides a set of results which match the posted query. Returning HttpResponseMessage object so as to obtain the response headers in the auto generated rest client.
     * 
     * @param query - The search query.
	 * @param entityType - the entity type
     * @param project - Project ID or project name
     */
    public async resultsCount(
        query: Search_Shared_Contracts.CountRequest,
        entityType: string,
        project?: string
    ): Promise<Search_Shared_Contracts.CountResponse> {

        const queryValues: { [key: string]: any } = {
            entityType: entityType
        };

        return this.beginRequest<Search_Shared_Contracts.CountResponse>({
            apiVersion: "5.0-preview.1",
            method: "POST",
            routeTemplate: "{project}/_apis/search/resultsCount",
            routeValues: {
                project: project
            },
            queryParams: queryValues,
            body: query
        });
    }

    /**
     * Provides an approximate count of results for posted query.
     * 
     * @param query - The search query.
     * @param entityType - The entity for which count query is done.
     */
    public async fetchPackageResultsCount(
        query: Search_Shared_Contracts.CountRequest,
        entityType?: string
    ): Promise<Search_Shared_Contracts.CountResponse> {

        const queryValues: any = {
            entityType: entityType
        };

        return this.beginRequest<Search_Shared_Contracts.CountResponse>({
            apiVersion: "5.0-preview.1",
            method: "POST",
            routeTemplate: "_apis/search/packageResultsCount",
            queryParams: queryValues,
            body: query
        });
    }

    /**
     * Provides a set of results which match the posted query.
     * 
     * @param query - The search query.
     */
    public async postTenantCodeQuery(
        query: Code.SearchQuery
    ): Promise<Code.CodeQueryResponse> {

        return this.beginRequest<Code.CodeQueryResponse>({
            apiVersion: "5.0-preview.1",
            method: "POST",
            routeTemplate: "_apis/search/tenantCodeQueryResults",
            body: query
        });
    }

    /**
     * Provides a set of results which match the posted query.
     * 
     * @param query - The search query.
     */
    public async postTenantWikiQuery(
        query: Search_Shared_Contracts.WikiSearchQuery
    ): Promise<Search_Shared_Contracts.WikiQueryResponse> {

        return this.beginRequest<Search_Shared_Contracts.WikiQueryResponse>({
            apiVersion: "5.0-preview.1",
            method: "POST",
            routeTemplate: "_apis/search/tenantWikiQueryResults",
            body: query
        });
    }
}

RestClients.add("Legacy.ISearchRestClient", {
    factory: SearchRestClient,
    options: {
        serviceInstanceType: "00000010-0000-8888-8000-000000000000"
    }
});
